
import { Slide } from '@hokify/hooper';
import { defineComponent } from 'vue';
import HokCarousel from './HokCarousel.vue';
import { truncateFct } from '../helpers/truncate';
import { quotes } from '../data/quotes';

export default defineComponent({
	name: 'PersonCarousel',
	components: {
		HokCarousel,
		Slide
	},
	methods: { truncateFct },
	data() {
		return {
			quotes
		};
	},
	props: {
		whiteBackground: { type: Boolean, default: false }
	}
});
